module.exports = __webpack_public_path__ + "img/call-to-action.6b905fff.png";